import { render, staticRenderFns } from "./DeleteTeamFromGridMatchMlbb.vue?vue&type=template&id=66ccd731&scoped=true"
import script from "./DeleteTeamFromGridMatchMlbb.vue?vue&type=script&lang=js"
export * from "./DeleteTeamFromGridMatchMlbb.vue?vue&type=script&lang=js"
import style0 from "./DeleteTeamFromGridMatchMlbb.vue?vue&type=style&index=0&id=66ccd731&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ccd731",
  null
  
)

export default component.exports